import api from '../utils/api';
import localStorageService from './localStorageService';
import { STRIPE_PAYMENT_STATUS } from '../constants/routes';

class PaymentService {
  public getPaymentStatus = async (providerSessionId: string) => {
    const userInfo = localStorageService.getUserInfo();
    const token = userInfo?.access_token || '';

    return api.get(STRIPE_PAYMENT_STATUS, {
      params: { provider_session_id: providerSessionId },
      headers: { Authorization: `Bearer ${token}` },
    });
  };
}

const paymentService = new PaymentService();
export default paymentService;

